export const SALES_PHONE_CLICK = 'SalesPhoneClick';
